import type { Component } from "solid-js";
import type { IconProps } from "./types";

const PlusIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      width={size}
      height={size}
      class={props.class}
    >
      <path d="M12 4.5v15m7.5-7.5h-15" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default PlusIcon;
